export default {
    materialReservations: [],
    materialReservationsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        reservationItemNumber: '',
    }
}